import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import dayjs from "dayjs";
import { toast } from 'react-hot-toast';
import { Dialog } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectFlightData,
  // selectFlightStatus,
  // selectFlightResults,
  // fetchFlightResults,
  fetchFlightResultsNew,
  // selectResultStatus,
  // setFlightsAndFilters,
  // setFlightsAndFiltersNew,
  // selectInterNationalSearch,
  selectRouteType,
  fetchFlights,
  fetchFareRules,
  resetFlightData,
  SearchqueryReissue,
} from "./flightSlice";
// import FlightFilters from "./FlightFilters";
import SearchForm from "./SearchForm";
import SearchSummaryBar from "./SearchSummaryBar";
import OneWayResult from "./OneWayResult";
import RoundTripResults from "./RoundTripResults";
import NomoreData from "./NomoreData";
import RoundInternationalResults from "./RoundInternationalResults";
import FlightSearchSkeleton from "./FlightSearchSkeleton";
import { processFlights } from "./processFlights";
import { selectCurrentUser } from "../auth/authSlice";
import { SaveGroupRequest, offlineTicketQueue } from "./flightSlice";
// import flightjson from "../../data/flight_city.json"; SaveGroupRequest
import { motion, AnimatePresence } from "framer-motion";
import { X } from 'lucide-react'
import { Users, User, Mail, Phone, Minus, Plus } from "lucide-react";
import CurFt from "../../components/CurFt";

const LAST_FLIGHT_SEARCH_KEY = 'lastFlightSearch';
const RECENT_FLIGHT_SEARCHES_KEY = 'recentFlightSearches';
const MAX_RECENT_FLIGHT = 6;


const FlightResultsPage = () => {
  const dispatch = useDispatch();
  const flightData = useSelector(selectFlightData);
  const user = useSelector(selectCurrentUser);

  const routeType = useSelector(selectRouteType);
  const { fareRulesStatus, fareRules } = useSelector(
    (state) => state.flights
  );
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const targetRef = useRef(null);

  const reissueData = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      BookingID: params.get("BookingID") || "",
      pnr: params.get("pnr") || "",
      passengers: JSON.parse(params.get("passengers")) || [],
    };
  }, [location.search]);

  const FormData = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      interNationalSearch: params.get("interNational"),
      routeType: params.get("JourneyType") || "",
      tripType: params.get("JourneyType") == "2" ? "roundtrip" : "oneway",
      TPSystemID: Number(params.get("TPSystemID") || 0),
      FareTypes: params.get("FareTypes") || "",
      selectedClass: (params.get("cabinClass") || "").toUpperCase(),
      adults: params.get("ADULT") || "0",
      children: params.get("CHILD") || "0",
      infants: params.get("INFANT") || "0",
      fromCode: params.get("fromCode") || "",
      toCode: params.get("toCode") || "",
      from: params.get("from") || "",
      to: params.get("to") || "",
      departureDate: params.get("departureDate") || "",
      returnDate: params.get("returnDate") || "",
      BookOffline: JSON.parse(params.get("BookOffline")),
      GroupRequest: JSON.parse(params.get("GroupRequest")),
      isDirectFlight: params.get("isDirectFlight"),
      isConnectingFlight: params.get("isConnectingFlight"),
      reissueData: reissueData,
      requestType: params.get("requestType") || 0,
      IsSfS: params.get("IsSfS") || 0,
    };
  }, [location.search]);

  const [loading, setloading] = useState(true);
  const [loading2, setloading2] = useState(true);
  const [FiltAirline, SetFiltAirline] = useState([]);
  const [Stops, SetStops] = useState([]);
  const [FiltPrice, SetFiltPrice] = useState([]);

  const [filteredInboundFlights, SetInbound] = useState([]);
  const [inboundFull, SetFullInbound] = useState([]);
  const [outboundFull, SetFullOutbound] = useState([]);
  const [filteredOutboundFlights, SetOutbound] = useState([]);

  const [PriceRange, setPriceRange] = useState([0, 0]);
  const [PriceRangeRound, setPriceRangeRound] = useState([0, 0]);
  const [FiltFareClassOutbound, SetFiltFareClassOutbound] = useState([]);
  const [FiltFareClassInbound, SetFiltFareClassInbound] = useState([]);

  const [recentFlightSearches, setRecentFlightSearches] = useState([]);

  const params = new URLSearchParams(window.location.search);
  const searchData = Object.fromEntries(params.entries());

  useEffect(() => {
    // localStorage.removeItem(RECENT_FLIGHT_SEARCHES_KEY);
    persistFlightSearch(searchData)
  }, []);
  function buildFlightSearchKey(payload) {
    const q = payload;
    const route = q;
    return [
      route?.fromCode, route?.toCode, route?.departureDate, route?.returnDate, route?.JourneyType,
      q?.ADULT, q?.CHILD, q?.INFANT, q?.cabinClass,
      q?.FareTypes, q?.IsSfS,
    ].join('|');
  }

  function persistFlightSearch(payload) {
    try {
      localStorage.setItem(LAST_FLIGHT_SEARCH_KEY, JSON.stringify(payload));
      const stored = localStorage.getItem(RECENT_FLIGHT_SEARCHES_KEY);
      let recent = stored ? JSON.parse(stored) : [];
      const currentKey = buildFlightSearchKey(payload);
      recent = recent.filter(p => buildFlightSearchKey(p) !== currentKey);
      recent.unshift(payload);
      recent = recent.slice(0, MAX_RECENT_FLIGHT);
      localStorage.setItem(RECENT_FLIGHT_SEARCHES_KEY, JSON.stringify(recent));
      setRecentFlightSearches(recent);
    } catch (e) {
      console.error('Failed to persist flight search', e);
    }
  }

  // Initialize search parameters for the SearchForm
  const [searchParams, setSearchParams] = useState({
    from: "",
    to: "",
    departureDate: new Date(),
    returnDate: null,
    tripType: routeType === "2" ? "roundtrip" : "oneway",
    routeType: parseInt(routeType || "1"),
    adults: 1,
    children: 0,
    infants: 0,
    selectedClass: "Economy/Premium Economy",
    travelers: "1 Adult, Economy",
  });
  useEffect(() => {

    //const agent_markup = JSON.parse(localStorage.getItem('agent_markup') || "[]");
    let agent_markup = [];

    try {
      const storedMarkup = localStorage.getItem("agent_markup");

      if (storedMarkup) {
        const parsedMarkup = JSON.parse(storedMarkup);

        if (Array.isArray(parsedMarkup)) {
          agent_markup = parsedMarkup;
        }
      }
    } catch (error) {
      console.error("Invalid agent_markup in localStorage:", error);
      localStorage.removeItem("agent_markup");
      agent_markup = [];
    }

    let match = {};
    if (parseInt(FormData.interNationalSearch) === 1) {
      match = agent_markup?.find(
        item => item.api_source_id === 1 && item.type === 1
      );
    } else {
      match = agent_markup?.find(
        item => item.api_source_id === 1 && item.type === 0
      );
    }

    const bookingId = FormData?.reissueData?.BookingID;
    const pnrreissue = FormData?.reissueData?.pnr;
    const searchQuery = {
      cabinClass: FormData.selectedClass.toUpperCase(),
      paxInfo: {
        ADULT: FormData.adults.toString(),
        CHILD: FormData.children.toString(),
        INFANT: FormData.infants.toString()
      },
      routeInfos: [
        {
          fromCityOrAirport: { code: FormData.fromCode },
          toCityOrAirport: { code: FormData.toCode },
          travelDate: FormData.departureDate
        },
        ...(FormData.routeType === '2' && FormData.returnDate
          ? [{
            fromCityOrAirport: { code: FormData.toCode },
            toCityOrAirport: { code: FormData.fromCode },
            travelDate: FormData.returnDate
          }]
          : [])
      ],
      searchModifiers: {
        pft: FormData.FareTypes,
        isDirectFlight: FormData?.isDirectFlight,
        isConnectingFlight: FormData?.isConnectingFlight
      },

    }



    const payload = {
      interNationalSearch: FormData.interNationalSearch,
      BookOffline: FormData?.BookOffline,
      JourneyType: FormData.routeType.toString(),
      TPSystemID: 0,
      agent_markup: match?.markup || 0,
      FareTypes: FormData.FareTypes,
      IsSfS: FormData.IsSfS ? 1 : "",
      reissueData: FormData?.reissueData || [],
      APIData: {
        searchQuery: searchQuery
      }
    };
    // console.log(payload);
    // return false;


    targetRef.current.scrollIntoView({ behavior: "smooth" });
    setOpen(false)
    setloading(true);
    SetOutbound([]);
    SetFullOutbound([]);
    SetFullInbound([]);
    SetInbound([]);
    if (pnrreissue !== undefined && pnrreissue !== null && pnrreissue !== "" && bookingId !== undefined && bookingId !== null && bookingId !== "") {
      ReissueSearchFlightsQuery(payload)
    } else {
      SearchFlightsQuery(payload)
    }

  }, [FormData]);

  const ReissueSearchFlightsQuery = async (payload) => {
    try {
      dispatch(resetFlightData())
      const response = await dispatch(SearchqueryReissue(payload)).unwrap();

    } catch (err) {

      // console.error("Flight search query failed:", err);
    } finally {
    }
  };
  const SearchFlightsQuery = async (payload) => {
    try {
      dispatch(resetFlightData())
      const response = await dispatch(fetchFlights(payload)).unwrap();
      if (!response?.data?.status?.success) {
        toast.error(response?.data?.message, { autoClose: 3000 });
        navigate(`/flight`);
      }
    } catch (err) {
      // console.error("Flight search query failed:", err);
    } finally {
    }
  };

  useEffect(() => {

    if (flightData?.resultSet?.length) {
      const currency = {
        CurrencyRate: "1",
        CurrencyTitle: process.env.REACT_APP_DEFAULT_CURRENCY || "INR",
        CurrencyId: 1,
      };
      let searchIDS = flightData?.resultSet;
      let reissue = flightData?.reissue || false;
      let index = 0;

      const fetchData = async () => {
        setloading(true);
        try {
          for (let searchId of flightData.resultSet) {
            const response = await dispatch(
              fetchFlightResultsNew({ searchId, currency, index, searchIDS, reissue })
            ).unwrap();
            localStorage.removeItem('ItineraryInfo');
            const { data } = response;

            const outbound_ = data.resultSet?.outbound || [];
            const inbound_ = data.resultSet?.inbound || [];
            // console.log("API Response:", data);
            SetFullOutbound(prev => [...prev, ...outbound_]);
            SetOutbound(prev => [...prev, ...outbound_]);

            SetFullInbound(prev => [...prev, ...inbound_]);
            SetInbound(prev => [...prev, ...inbound_]);


            const Airlines = data.resultSet?.FiltAirlineName || [];
            const Stops = data?.resultSet?.FiltStop || [];
            const Price = data?.resultSet?.FiltPrice || [];
            // console.log(Airlines);

            // SetFiltAirline((prev) => prev.concat(Airlines));
            // SetFiltAirline(prev => [...prev, ...Airlines]);

            SetFiltAirline(prev => {
              if (!Array.isArray(Airlines) || Airlines.length === 0) return prev;
              let newState = [...prev];
              Airlines.forEach((innerArray, index) => {
                if (!Array.isArray(innerArray)) return;
                if (!newState[index]) {
                  newState[index] = [...innerArray];
                } else {
                  const merged = [...newState[index], ...innerArray];
                  newState[index] = Array.from(new Set(merged));
                }
              });
              return newState;
            });


            // SetStops((prev) => prev.concat(Stops));
            SetStops(prev => {
              if (!Array.isArray(Stops) || Stops.length === 0) return prev;
              let newState = [...prev]; // copy
              Stops.forEach((innerArray, index) => {
                if (!Array.isArray(innerArray)) return;
                if (!newState[index]) {
                  newState[index] = [...innerArray];
                } else {
                  const merged = [...newState[index], ...innerArray];
                  newState[index] = Array.from(new Set(merged));
                }
              });
              return newState;
            });

            // SetFiltPrice((prev) => prev.concat(Price));
            // if (Price.length > 0) {
            //   setPriceRange([Price[0]?.Minpr, Price[0]?.Maxpr])
            //   if (FormData.routeType == '2' && FormData.interNationalSearch == "0") {
            //     setPriceRangeRound([Price[1].Minpr, Price[1].Maxpr])
            //   }
            // }
            SetFiltPrice((prev) => {
              const merged = [...prev, ...Price].filter(Boolean);
              const allMin = merged.map(item => item?.Minpr).filter(v => v != null);
              const allMax = merged.map(item => item?.Maxpr).filter(v => v != null);
              if (allMin.length > 0 && allMax.length > 0) {
                const globalMin = Math.min(...allMin);
                const globalMax = Math.max(...allMax);
                setPriceRange([globalMin, globalMax]);
                if (FormData.routeType == '2' && FormData.interNationalSearch == "0" && merged[1]) {
                  const minRound = merged[1]?.Minpr ?? globalMin;
                  const maxRound = merged[1]?.Maxpr ?? globalMax;
                  setPriceRangeRound([minRound, maxRound]);
                }
              }
              return merged;
            });



            if (Price.length > 0) {
              if (Price[0]?.length > 0) {
                setPriceRange([Price[0][0].Minpr, Price[0][0].Maxpr]);
              }
              if (FormData.routeType == '2' && FormData.interNationalSearch == "0") {
                if (Price[1]?.length > 0) {
                  setPriceRangeRound([Price[1][0].Minpr, Price[1][0].Maxpr]);
                }
              }
            }




            const FareclassfiltOutbount = [...new Set(
              data.resultSet.outbound.flatMap(flight => {
                if (!flight?.FareList || !Array.isArray(flight.FareList)) {
                  console.log("blank");

                  return [];
                }
                return flight.FareList.map(fare => fare?.fareIdentifier).filter(Boolean);
              })
            )];
            let FareclassfiltInbound = []
            if (FormData.routeType == "2" && FormData.interNationalSearch == "0") {
              FareclassfiltInbound = [...new Set(
                data.resultSet.inbound.flatMap(flight => {
                  if (!flight?.FareList || !Array.isArray(flight.FareList)) {
                    return [];
                  }
                  return flight.FareList.map(fare => fare?.fareIdentifier).filter(Boolean);
                })
              )];
              SetFiltFareClassInbound((prev) => prev.concat(FareclassfiltInbound));

            }

            SetFiltFareClassOutbound((prev) => [...new Set([...prev, ...FareclassfiltOutbount, ...FareclassfiltInbound])]);
            if (outbound_.length > 0) {
              setloading(false);
            }
          }
          setloading2(false);
          setloading(false);
        } catch (error) {
          setloading(false);
          setloading2(false);
          console.error("Error:", error);
        }
      }
      fetchData();
      // fetchData(flightData.resultSet, currency, index, searchIDS);
      // flightData.resultSet.forEach((searchId) => {
      //   fetchData(searchId, currency, index, searchIDS);
      //   // if (!resultStatus[searchId] || resultStatus[searchId] === "failed") {
      //   //   dispatch(fetchFlightResultsNew({ searchId, currency, index, searchIDS }));
      //   // }
      //   // index++;
      // });





      // const allResolved = flightData.resultSet.every(
      //   (searchId) =>
      //     resultStatus[searchId] === "succeeded" ||
      //     resultStatus[searchId] === "failed"
      // );
      // if (allResolved) {
      //   dispatch(setFlightsAndFilters(flightData.resultSet));
      // }
    }
  }, [flightData]);


  const [selectedStops, setSelectedStops] = useState([]);
  const [selectedAirlines, setSelectedAirlines] = useState([]);
  const [selectedDeparture, setSelectedDeparture] = useState([]);
  const [selectedArrival, setSelectedArrival] = useState([]);

  const [selectedStopsInbound, setSelectedStopsInbound] = useState([]);
  const [selectedAirlinesInbound, setSelectedAirlinesInbound] = useState([]);
  const [selectedDepartureInbound, setSelectedDepartureInbound] = useState([]);
  const [selectedArrivalInbound, setSelectedArrivalInbound] = useState([]);
  const [FiltAirlineSSP, setFiltAirlineSSP] = useState([]);
  const [selectedAirlineSSP, setSelectedAirlineSSP] = useState([]);
  const [selectedFarepol, setSelectedFarepol] = useState([]);
  const [selectedFareClassOutbound, setSelectedFareClassOutbound] = useState([]);
  const [selectedFareClassInbound, setSelectedFareClassInbound] = useState([]);


  const handleChangeStops = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedStops([...selectedStops, value])
    } else {
      setSelectedStops(selectedStops.filter((event) => event !== value))
    }
  };

  const handleChangeStopsInbound = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedStopsInbound([...selectedStopsInbound, value])
    } else {
      setSelectedStopsInbound(selectedStopsInbound.filter((event) => event !== value))
    }
  };

  const handleChangeAirlines = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedAirlines([...selectedAirlines, value])
    } else {
      setSelectedAirlines(selectedAirlines.filter((event) => event !== value))
    }
  };

  const handleChangeAirlinesInbound = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedAirlinesInbound([...selectedAirlinesInbound, value])
    } else {
      setSelectedAirlinesInbound(selectedAirlinesInbound.filter((event) => event !== value))
    }
  };


  const priceRangeFilter = (event) => {
    setPriceRange([event[0], event[1]])
  }

  const handleChangeDeparture = (event) => {

    const { value, checked } = event.target;
    if (checked) {
      setSelectedDeparture([...selectedDeparture, value]);
    } else {
      setSelectedDeparture(selectedDeparture.filter((v) => v !== value));
    }
  };
  const handleChangeArrival = (event) => {

    const { value, checked } = event.target;
    if (checked) {
      setSelectedArrival([...selectedArrival, value]);
    } else {
      setSelectedArrival(selectedArrival.filter((v) => v !== value));
    }
  };

  const handleChangeDepartureInbound = (event) => {

    const { value, checked } = event.target;
    if (checked) {
      setSelectedDepartureInbound([...selectedDepartureInbound, value]);
    } else {
      setSelectedDepartureInbound(selectedDepartureInbound.filter((v) => v !== value));
    }
  };



  const handleChangeArrivalInbound = (event) => {

    const { value, checked } = event.target;
    if (checked) {
      setSelectedArrivalInbound([...selectedArrivalInbound, value]);
    } else {
      setSelectedArrivalInbound(selectedArrivalInbound.filter((v) => v !== value));
    }
  };

  const handleAirlineNameSSP = (event) => {

    const { value, checked } = event.target;

    if (checked) {
      setSelectedAirlineSSP([...selectedAirlineSSP, value]);
    } else {
      setSelectedAirlineSSP(selectedAirlineSSP.filter((v) => v !== value));
    }
  };

  const handleChangeFarepol = (event) => {
    const { value, checked } = event.target;

    if (value === 'NA') {
      setSelectedFarepol([]);
    } else
      if (checked) {
        setSelectedFarepol([value])
      } else {
        setSelectedFarepol(selectedFarepol.filter((event) => event !== value))
      }

  };
  const handleFareClassOutbound = (event) => {
    const { value, checked } = event.target;
    if (value === 'NA') {
      setSelectedFareClassOutbound([]);
    } else
      if (checked) {
        setSelectedFareClassOutbound([value])
      } else {
        setSelectedFareClassOutbound(selectedFareClassOutbound.filter((event) => event !== value))
      }
  };

  const handleFareClassInbound = (event) => {
    const { value, checked } = event.target;
    if (value === 'NA') {
      setSelectedFareClassInbound([]);
    } else
      if (checked) {
        setSelectedFareClassInbound([value])
      } else {
        setSelectedFareClassInbound(selectedFareClassInbound.filter((event) => event !== value))
      }
  };

  const [showSpecialReturn, setShowSpecialReturn] = useState(false);
  const applyFilters = () => {
    let updatedList = processFlights(outboundFull)
    let updatedListInbound = inboundFull
    //const flights = processFlights(updatedList);
    //console.log(flights);

    if (showSpecialReturn) {

      updatedList = updatedList.map(flight => ({
        ...flight,
        FareList: flight.FareList.filter(fare => fare.fareIdentifier === "SPECIAL RETURN")
      })).filter(f => f.FareList.length > 0);

      updatedListInbound = updatedListInbound.map(flight => ({
        ...flight,
        FareList: flight.FareList.filter(fare => fare.fareIdentifier === "SPECIAL RETURN")
      })).filter(f => f.FareList.length > 0);

      const FiltAirlineSSP = Array.from(
        new Map(updatedList.map(f => [f.AirlineName, { AirlineName: f.AirlineName, logo: f.logo }])).values()
      );
      setFiltAirlineSSP((FiltAirlineSSP));


    } else {

      updatedList = updatedList.map(flight => ({
        ...flight,
        FareList: flight.FareList.filter(fare => fare.fareIdentifier !== "SPECIAL RETURN")
      })).filter(f => f.FareList.length > 0);

      updatedListInbound = updatedListInbound.map(flight => ({
        ...flight,
        FareList: flight.FareList.filter(fare => fare.fareIdentifier !== "SPECIAL RETURN")
      })).filter(f => f.FareList.length > 0);
    }

    if (selectedAirlineSSP.length) {
      updatedList = updatedList.filter(f => selectedAirlineSSP.includes(f.AirlineName))
      updatedListInbound = updatedListInbound.filter(f => selectedAirlineSSP.includes(f.AirlineName))

    }

    if (selectedStops.length) {
      if (FormData.interNationalSearch == '1' && FormData.routeType == '2') {
        updatedList = updatedList.filter(f => selectedStops.includes(f.org.StopCount))
      } else {
        updatedList = updatedList.filter(f => selectedStops.includes(f.StopCount))
      }
    }
    if (selectedFarepol.length) {
      if (FormData.interNationalSearch == '1' && FormData.routeType == '2') {
        updatedList = updatedList.filter(f => {
          const matchedIndex = f.FareList.findIndex(rule => {
            const value = rule.IsRefundable;
            let numericValue;
            if (typeof value === 'boolean') {
              numericValue = value ? 1 : 0;
            } else if (typeof value === 'number') {
              numericValue = value;
            } else {
              numericValue = parseInt(value) || 0;
            }

            return numericValue == selectedFarepol;
          });

          if (matchedIndex !== -1) {
            const [matchedRule] = f.FareList.splice(matchedIndex, 1);
            f.FareList.unshift(matchedRule);
            return true;
          }
          return false;
        });
      } else if (FormData.interNationalSearch == '0' && FormData.routeType == '2') {
        updatedListInbound = updatedListInbound.filter(f => {
          const matchedIndex = f.FareList.findIndex(rule => {
            const value = rule.IsRefundable;
            let numericValue;
            if (typeof value === 'boolean') {
              numericValue = value ? 1 : 0;
            } else if (typeof value === 'number') {
              numericValue = value;
            } else {
              numericValue = parseInt(value) || 0;
            }

            return numericValue == selectedFarepol;
          });

          if (matchedIndex !== -1) {
            const [matchedRule] = f.FareList.splice(matchedIndex, 1);
            f.FareList.unshift(matchedRule);
            return true;
          }
          return false;
        });


        updatedList = updatedList.filter(f => {
          const matchedIndex = f.FareList.findIndex(rule => {
            const value = rule.IsRefundable;
            let numericValue;
            if (typeof value === 'boolean') {
              numericValue = value ? 1 : 0;
            } else if (typeof value === 'number') {
              numericValue = value;
            } else {
              numericValue = parseInt(value) || 0;
            }

            return numericValue == selectedFarepol;
          });

          if (matchedIndex !== -1) {
            const [matchedRule] = f.FareList.splice(matchedIndex, 1);
            f.FareList.unshift(matchedRule);
            return true;
          }
          return false;
        });
      } else {
        updatedList = updatedList.filter(f => {
          const matchedIndex = f.FareList.findIndex(rule => {
            const value = rule.IsRefundable;
            let numericValue;
            if (typeof value === 'boolean') {
              numericValue = value ? 1 : 0;
            } else if (typeof value === 'number') {
              numericValue = value;
            } else {
              numericValue = parseInt(value) || 0;
            }

            return numericValue == selectedFarepol;
          });

          if (matchedIndex !== -1) {
            const [matchedRule] = f.FareList.splice(matchedIndex, 1);
            f.FareList.unshift(matchedRule);
            return true;
          }
          return false;
        });
      }
    }
    if (selectedFareClassOutbound.length) {
      if (FormData.interNationalSearch == '1' && FormData.routeType == '2') {
        updatedList = updatedList.filter(f => {
          const matchedIndex = f.FareList.findIndex(rule => rule.fareIdentifier == selectedFareClassOutbound);
          if (matchedIndex !== -1) {
            const [matchedRule] = f.FareList.splice(matchedIndex, 1);
            f.FareList.unshift(matchedRule);
            return true;
          }
          return false;
        });
      } else if (FormData.interNationalSearch == '0' && FormData.routeType == '2') {


        updatedListInbound = updatedListInbound.filter(f => {
          const matchedIndex = f.FareList.findIndex(rule => rule.fareIdentifier == selectedFareClassOutbound);
          if (matchedIndex !== -1) {
            const [matchedRule] = f.FareList.splice(matchedIndex, 1);
            f.FareList.unshift(matchedRule);
            return true;
          }
          return false;
        })

        updatedList = updatedList.filter(f => {
          const matchedIndex = f.FareList.findIndex(rule => rule.fareIdentifier == selectedFareClassOutbound);
          if (matchedIndex !== -1) {
            const [matchedRule] = f.FareList.splice(matchedIndex, 1);
            f.FareList.unshift(matchedRule);
            return true;
          }
          return false;
        });
      } else {
        updatedList = updatedList.filter(f => {
          const matchedIndex = f.FareList.findIndex(rule => rule.fareIdentifier == selectedFareClassOutbound);
          if (matchedIndex !== -1) {
            const [matchedRule] = f.FareList.splice(matchedIndex, 1);
            f.FareList.unshift(matchedRule);
            return true;
          }
          return false;
        });
      }
    }


    if (selectedAirlines.length) {
      if (FormData.interNationalSearch == '1' && FormData.routeType == '2') {
        updatedList = updatedList.filter(f => selectedAirlines.includes(f.org.AirlineName))
      } else {
        updatedList = updatedList.filter(f => selectedAirlines.includes(f.AirlineName))
      }
    }

    if (PriceRange[0] > 0 && PriceRange[1] > 0) {
      updatedList = updatedList.filter(f => parseFloat(PriceRange[0] - 1) <= f.FareList[0].PublishedFare && parseFloat(PriceRange[1]) >= f.FareList[0].PublishedFare)
    }

    if (selectedDeparture.length) {
      if (FormData.interNationalSearch == '1' && FormData.routeType == '2') {
        updatedList = updatedList.filter(f => selectedDeparture.includes(f.org.FilDetime))
      } else {
        updatedList = updatedList.filter(f => selectedDeparture.includes(f.FilDetime))
      }
    }

    if (selectedArrival.length) {
      if (FormData.interNationalSearch == '1' && FormData.routeType == '2') {
        updatedList = updatedList.filter(f => selectedArrival.includes(f.org.FilArtime))
      } else {
        updatedList = updatedList.filter(f => selectedArrival.includes(f.FilArtime))
      }
    }


    if (selectedStopsInbound.length) {
      updatedListInbound = updatedListInbound.filter(f => selectedStopsInbound.includes(f.StopCount))
    }

    if (PriceRange[0] > 0 && PriceRange[1] > 0) {
      updatedListInbound = updatedListInbound.filter(f => parseFloat(PriceRange[0] - 1) <= f.FareList[0].PublishedFare && parseFloat(PriceRange[1]) >= f.FareList[0].PublishedFare)
    }

    if (selectedAirlinesInbound.length) {
      updatedListInbound = updatedListInbound.filter(f => selectedAirlinesInbound.includes(f.AirlineName))
    }

    if (selectedDepartureInbound.length) {
      updatedListInbound = updatedListInbound.filter(f => selectedDepartureInbound.includes(f.FilDetime))
    }
    if (selectedArrivalInbound.length) {
      updatedListInbound = updatedListInbound.filter(f => selectedArrivalInbound.includes(f.FilArtime))
    }

    if (updatedList) {
      SetOutbound([...updatedList])
    }
    if (updatedListInbound) {
      SetInbound([...updatedListInbound])
    }
    setVisibleCount(20)

  }


  useEffect(() => {
    applyFilters();
  }, [selectedStops, selectedAirlines, PriceRange, selectedDeparture, selectedArrival, selectedStopsInbound, selectedAirlinesInbound, selectedDepartureInbound, selectedArrivalInbound, showSpecialReturn, selectedAirlineSSP, selectedFarepol, selectedFareClassOutbound, selectedFareClassInbound])

  const loaderRoundRef = useRef(null);
  const loaderSingleRef = useRef(null);
  const loaderRef = useRef(null);
  const pageSize = 20; // number of flights per load
  const [visibleCount, setVisibleCount] = useState(pageSize);
  const [visibleCountRound, setVisibleCountRound] = useState(pageSize);
  const [visibleFlights, setVisibleFlights] = useState([]);
  const [offlineTicket, setofflineTicketQueue] = useState([]);
  const [visibleFlightsRound, setvisibleFlightsRound] = useState([]);
  const [GroupRequestLoad, setGroupRequestLoad] = useState(false);
  const [grouprequestData, setgrouprequestData] = useState({
    BookingID: '',
    numberOfPax: '',
    adult: parseInt(FormData?.adults) || 1,
    child: parseInt(FormData?.children) || 0,
    infant: parseInt(FormData?.infants) || 0,
    email: user?.UserData?.email || '',
    name: user?.UserData?.name || '',
    mobile: user?.UserData?.mobile || '',
    FlightBooking: [],
  });

  useMemo(() => {
    const sorted = [...filteredOutboundFlights]
      .sort((a, b) => a.PubFare - b.PubFare)
      .slice(0, visibleCount);
    setVisibleFlights(sorted);
  }, [filteredOutboundFlights, visibleCount]);

  useMemo(() => {
    const sortedRound = [...filteredInboundFlights]
      .sort((a, b) => a.PubFare - b.PubFare)
      .slice(0, visibleCountRound);
    setvisibleFlightsRound(sortedRound);
  }, [filteredInboundFlights, visibleCountRound]);



  useEffect(() => {

    if (!loaderRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisibleCount((prev) => {
            if (prev >= filteredOutboundFlights.length) return prev;
            return prev + pageSize;
          });
        }
      },
      { threshold: 1.0 }
    );
    observer.observe(loaderRef.current);
    return () => {
      if (loaderRef.current) observer.unobserve(loaderRef.current);
    };
  }, [filteredOutboundFlights.length, loaderRef]);

  useEffect(() => {
    if (!loaderRoundRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisibleCountRound((prev) => {
            if (prev >= filteredInboundFlights.length) return prev;
            return prev + pageSize;
          });
        }
      },
      { threshold: 1.0 }
    );
    observer.observe(loaderRoundRef.current);
    return () => {
      if (loaderRoundRef.current) observer.unobserve(loaderRoundRef.current);
    };
  }, [filteredInboundFlights.length, loaderRoundRef]);

  const normalize = (dt) => dt ? dt.replace(' ', 'T').slice(0, 16) : '';
  const isInQueue = (bookings, queue) => {
    return bookings.some(booking =>
      queue.some(q =>
        q.SoCode === booking.SoCode &&
        q.DeCode === booking.DeCode &&
        q.AirlineCode === booking.AirlineCode &&
        q.FlightNumber === booking.FlightNumber &&
        normalize(q.FromUTCTime) === normalize(booking.FromUTCTime) &&
        normalize(q.ToUTCTime) === normalize(booking.ToUTCTime)
      )
    );
  };

  const handleBookNow = (selectedOnward, price, priceReturn = null, selectedReturn = null) => {
    let updatedReturn = []
    const updatedOnward = {
      ...selectedOnward,
      FareList: price, // replace array with new object
      FareLists: price, // replace array with new object
    };
    if (priceReturn && selectedReturn) {
      updatedReturn = {
        ...selectedReturn,
        FareList: priceReturn, // replace array with new object
        FareLists: priceReturn, // replace array with new object
      };
    }
    let MakeArray = (selectedReturn) ? [updatedOnward, updatedReturn] : [updatedOnward];
    if (FormData.BookOffline) {
      const InQueue = isInQueue(MakeArray, offlineTicket)
      if (InQueue) {
        toast.error('A booking request for this flight is currently being reviewed. Please hold on until it is approved or declined before making a new request.', { autoClose: 2000 });
        return false;
      }
    }
    const itinerary = {
      ItineraryInfo: MakeArray.map((flight) => ({
        FlightDetails: flight.Segments.map((seg) => ({
          FlightID: seg.segmentsId,
          FlightNumber: seg.FlightNumber.replace("-", " ").replace(" +1", ""),
          Origin: seg.originAirportCode,
          Destination: seg.destinationAirportCode,
          DepartureDateTime: dayjs(seg.originDepTime).format("DD MMM YYYY HH:mm"),
          ArrivalDateTime: dayjs(seg.destinationArrTime).format("DD MMM YYYY HH:mm"),
        })),
        BaseAmount: flight?.FareList?.APIBaseFare?.toString() || '0',
        GrossAmount: flight.FareList.intPublishedFare.toString(),
      })),
    };

    localStorage.setItem('ItineraryInfo', JSON.stringify(itinerary))
    if (FormData.GroupRequest === true) {
      setgrouprequestData((prev) => ({
        ...prev,
        BookingID: selectedOnward.searchId,              // or booking.booking_id
        FlightBooking: MakeArray || [], // array of flights
      }));
      setGroupRequestLoad(true)
      return false;
    }


    let reissue = flightData?.reissue || false;
    if (FormData.routeType == 2 && FormData.interNationalSearch == 0) {
      navigate(`/flight/itinerary?searchId=${selectedOnward.searchId}&PriceID=${price.PriceID + ',' + priceReturn.PriceID}&reissue=${reissue}`);
    } else if (FormData.routeType == 1) {
      navigate(`/flight/itinerary?searchId=${selectedOnward.searchId}&PriceID=${price.PriceID}&reissue=${reissue}`);
    } else if (FormData.routeType == 2 && FormData.interNationalSearch == 1) {
      navigate(`/flight/itinerary?searchId=${selectedOnward.searchId}&PriceID=${price.PriceID}&reissue=${reissue}`);
    }
  }
  const [errors, setErrors] = useState({});

  const [adultsCount, setAdultsCount] = useState(parseInt(FormData?.adults) || 1);
  const [childrenCount, setChildrenCount] = useState(parseInt(FormData?.children) || 0);
  const [infantCount, setInfantCount] = useState(parseInt(FormData?.infants) || 0);
  const handleGroupRequestSubmit = async () => {
    const newErrors = {};

    // Pax validation
    if (!grouprequestData.numberOfPax || Number(grouprequestData.numberOfPax) <= 9) {
      newErrors.numberOfPax = "Number of passengers must be greater than 9";
    }

    // Required fields
    if (!grouprequestData.name?.trim()) {
      newErrors.name = "Name is required";
    }

    if (!grouprequestData.email?.trim()) {
      newErrors.email = "Email is required";
    }

    if (!grouprequestData.mobile?.trim()) {
      newErrors.mobile = "Mobile number is required";
    }

    // Stop if validation fails
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Clear errors
    setErrors({});

    // Final payload
    const payload = {
      ...grouprequestData,
    };

    try {
      const response = await dispatch(
        SaveGroupRequest({ payload })
      ).unwrap();
      if (response.data.status.success) {
        setGroupRequestLoad(false)
        toast.success(response.data.message, { autoClose: 2000 });
      } else {
        toast.error(response.data.message, { autoClose: 2000 });
      }
      // console.log("API Response:", response);
    } catch (error) {
      console.error("Error:", error);
    }
    // API call
    // api.post("/group-booking", payload);
  };


  const [isSectorModalOpen, setIsModalSector] = useState(false);
  const [FlightSelected, setFlightSelected] = useState(false);
  const [FlightPrice, setFlightPrice] = useState(false);
  const [activeTab, setActiveTab] = useState("flight");
  const [showRules, setShowRules] = useState(false);
  const handlFlightDeatils = (selectedOnward, price, priceReturn = null) => {
    setActiveTab('flight')
    setIsModalSector(true)
    setFlightSelected(selectedOnward)
    setFlightPrice(price)

    if (activeTab === "cancellation") {
      handlFareRules()
    }

  }
  const handlFareRules = () => {
    const currency = {
      CurrencyRate: FlightPrice?.CurrencyRate,
      CurrencyTitle: FlightPrice?.Currency,
      CurrencyId: FlightPrice?.currencySysId,
    };



    if (FormData?.BookOffline === 'false' || FormData?.BookOffline === false) { // && FlightSelected?.Supplier !== 7
      dispatch(
        fetchFareRules({
          priceId: FlightPrice?.PriceID,
          searchId: FlightSelected?.searchId,
          currency,
        })
      );
    }
    setShowRules(true);
  }

  const tabs = [
    { key: "flight", label: "Flight Information" },
    { key: "fare", label: "Fare Details" },
    { key: "baggage", label: "Baggage Information" },
    { key: "cancellation", label: "Cancellation & Fare Rule" },
  ];
  // if (hasError) {
  //   return (
  //     <div className="flex justify-center items-center min-h-screen bg-gray-50">
  //       <div className="text-center">
  //         <p className="text-red-600 font-semibold">Failed to load flights.</p>
  //         <p className="text-gray-600 mt-2">
  //           Please try again or modify your search.
  //         </p>
  //         <button
  //           className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
  //           onClick={() =>
  //             dispatch(setFlightsAndFilters(flightData?.resultSet || []))
  //           }
  //           aria-label="Retry loading flights"
  //         >
  //           Retry
  //         </button>
  //       </div>
  //     </div>
  //   );
  // }

  const formatType = (key) => {
    switch (key) {
      case 'CANCELLATION': return 'CANCELLATION CHARGES';
      case 'DATECHANGE': return 'DATECHANGE CHARGES';
      case 'NO_SHOW': return 'NO SHOW CHARGES';
      case 'SEAT_CHARGEABLE': return 'SEAT CHARGEABLE';
      default: return key.replace(/_/g, ' ').toUpperCase();
    }
  };
  const renderPolicySection = (title, items) => (
    <div key={title} className="bg-blue-50 rounded-md overflow-hidden shadow-md border border-blue-100 mb-4">
      <div className="bg-blue-100 px-4 py-2 text-sm font-semibold text-gray-800">
        {formatType(title)}
        <span className="text-xs font-normal italic ml-1">
          Mentioned fees are Per Pax Per Sector
        </span>
      </div>
      <div className="px-4 py-3 border-t bg-blue-50 text-sm text-gray-700">
        <div className="flex flex-wrap gap-y-2">
          <div className="w-full md:w-1/4">Time Frame Cancellation</div>
          <div className="w-full md:w-1/4">Airline Fees</div>
          <div className="w-full md:w-1/4">Service Fee</div>
          <div className="w-full md:w-1/4">Charges & Description</div>
        </div>
      </div>
      {Array.isArray(items) && items.map((item, idx) => (
        <div key={idx} className="px-4 py-3 border-t bg-white text-sm text-gray-700 overflow-x-auto">
          <div className="flex flex-wrap gap-y-2">
            <div className="w-full md:w-1/4 font-medium">{item.TimeFrame}</div>
            <div className="w-full md:w-1/4 font-medium"><CurFt currency={item?.CurrencyTitle || "INR"} price={item.amount || 0} /></div>
            <div className="w-full md:w-1/4 font-medium"><CurFt currency={item?.CurrencyTitle || "INR"} price={item.additionalFee || 0} /></div>
            <div className="w-full md:w-1/4 pt-2 text-gray-600">
              {/* {item.policyInfo?.map((line, i) => (
                <p key={i} dangerouslySetInnerHTML={{ __html: line.replace(/__nls__/g, '') }}></p>
              ))} */}
              {item.policyInfo
                ?.flat()
                ?.filter((line) => typeof line === "string" && line.trim() !== "")
                ?.map((line, i) => (
                  <p
                    key={i}
                    dangerouslySetInnerHTML={{
                      __html: line.replace(/__nls__/g, ""),
                    }}
                  />
                ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const renderFareRulesUI = () => {
    if (!fareRules || typeof fareRules !== 'object') return null;

    const sectors = Object.keys(fareRules);
    return sectors.map((sector) => {
      const policies = fareRules[sector];
      return (
        <div key={sector}>
          <h3 className="text-blue-700 font-bold mb-2">{sector}</h3>
          {Object.entries(policies).map(([type, items]) =>
            renderPolicySection(type, items)
          )}
        </div>
      );
    });
  };

  const renderFarePolicy = () => (
    <>
      {(() => {
        if (FormData?.BookOffline === 'false' || FormData?.BookOffline === false) {
          return (
            <div className="text-sm space-y-4">
              <p className="text-gray-700">
                Refundable: {FlightPrice?.RefundableTxt || "Non Refundable"}
              </p>
              <p className="text-gray-700">Fare Type: {FlightPrice?.fareIdentifier || "Standard"}</p>

              {fareRulesStatus === "loading" && <p className="text-gray-500">Loading fare rules...</p>}
              {fareRulesStatus === "succeeded" && showRules && renderFareRulesUI()}
              {fareRulesStatus === "failed" && showRules && (
                <p className="text-sm text-red-600">Failed to load fare rules.</p>
              )}
            </div>
          )
        } else if (FlightSelected && FlightSelected?.Supplier === 7) {
          return (
            <div className="text-sm space-y-4">
              <div className="text-wrap">
                <ul className="list-disc list-inside space-y-1 mt-0">
                  <li>
                    We kindly request you to inform us of any required name updates for your
                    return flight at least 48 hours before the departure of your onward
                    flight.
                  </li>
                  <li>This ticket is Non Refundable &amp; Non Changeable.</li>
                  <li>
                    All Guests, including children and infants, must present valid
                    identification at check-in.
                  </li>
                  <li>
                    Check-in begins 2 hours prior to the flight for seat assignment and closes
                    45 minutes prior to the scheduled departure.
                  </li>
                  <li>Please contact airlines for Terminal Queries.</li>
                  <li>
                    Charged fare is totally agreed between "BUYER &amp; SELLER", any issues
                    related to fares thereafter will not be entertained.
                  </li>
                  <li>
                    Please check the figures / timings as they may change time to time without
                    any notice to the passenger.
                  </li>
                  <li>
                    We are not responsible for any flight delay/cancellation from the
                    airline's end. Kindly contact the airline at least 24 hrs before to
                    reconfirm your flight details giving reference of airline PNR number.
                  </li>
                  <li>Name changes are not permitted for any flights.</li>
                  <li>For Infants valid birth certificate is required.</li>
                  <li>
                    As per government directives, Web Check-in is mandatory for all passengers
                    before the scheduled departure of their domestic flight. Charges may
                    apply.
                  </li>
                  <li>
                    Carriage and other services provided by the carrier are subject to
                    conditions of carriage, which are hereby incorporated by reference. These
                    conditions may be obtained from the issuing carrier.
                  </li>
                  <li>
                    Transportation and other services provided by the carrier are subjected to
                    conditions of contract and other important notices. Please ensure that you
                    have received these notices, and if not, contact the booking partner or
                    issuing carrier to obtain a copy prior to the commencement of your trip.
                  </li>
                  <li>
                    If the passenger journey involves an ultimate destination or stop in a
                    country other than the country of departure, the Warsaw Convention may be
                    applicable and this convention governs and on most case limits the
                    liability of carriers for death or personal injury and in respect of loss
                    of or damage to baggage.
                  </li>
                  <li>
                    In case a flight gets cancelled, we will not be liable to provide any
                    alternate flights within the same cost, any additional cost incurred for
                    the same shall be borne by the traveler.
                  </li>
                  <li>
                    Due to the impact of COVID-19 worldwide, refunds will be processed in
                    accordance with the latest airline policies. Please note that at the
                    airline's discretion, refunds may be made in the form of airline vouchers.
                    The final decision regarding the refund method will be made by the
                    airline. Some airlines may charge processing fees for flight changes or
                    cancellations made due to flight schedule changes. Actual fees charged
                    will depend on the final decision by the airline.
                  </li>
                  <li>
                    In case of IROP or flight cancellation by airline, full refund after
                    deduction of service charge (Rs 250 per person) will be provided.
                  </li>
                </ul>
              </div>


            </div>
          )
        } else if (FormData?.reissueData) {
          return (
            <div className="text-sm space-y-4">
              <p className="text-gray-700">
                4 hrs to 365 days
              </p>
              <p className="text-blue-600">
                Refundable subject to cancellation penalty
              </p>
              <p className="text-blue-600">
                Please Note: Fare rules are subject to change without any notice
              </p>
            </div>
          )
        } else {
          <div className="text-sm space-y-4">
            <p className="text-gray-700">
              The ticket is non refundable.!
            </p>
            <p className="text-blue-600">
              We promise your ticket will be issue  in 30 minutes or you’ll earn GT Coins. That’s our guarantee.”
            </p>
          </div>
        }
      })()}
      {/* {FormData?.BookOffline === 'false' ? (
        <div className="text-sm space-y-4">
          <p className="text-gray-700">
            Refundable: {FlightPrice?.RefundableTxt || "Non Refundable"}
          </p>
          <p className="text-gray-700">Fare Type: {FlightPrice?.fareIdentifier || "Standard"}</p>

          {fareRulesStatus === "loading" && <p className="text-gray-500">Loading fare rules...</p>}
          {fareRulesStatus === "succeeded" && showRules && renderFareRulesUI()}
          {fareRulesStatus === "failed" && showRules && (
            <p className="text-sm text-red-600">Failed to load fare rules.</p>
          )}
        </div>
      ) : (
        <>
          {FormData?.reissueData ? (
            <div className="text-sm space-y-4">
              <p className="text-gray-700">
                4 hrs to 365 days
              </p>
              <p className="text-blue-600">
                Refundable subject to cancellation penalty
              </p>
              <p className="text-blue-600">
                Please Note: Fare rules are subject to change without any notice
              </p>
            </div>
          ) : (
            <div className="text-sm space-y-4">
              <p className="text-gray-700">
                The ticket is non refundable.!
              </p>
              <p className="text-blue-600">
                We promise your ticket will be issue  in 30 minutes or you’ll earn GT Coins. That’s our guarantee.”
              </p>
            </div>
          )}
        </>
      )} */}
    </>
  );
  useEffect(() => {
    setgrouprequestData((prev) => ({
      ...prev,
      numberOfPax: (adultsCount + childrenCount + infantCount),
      adult: adultsCount,
      child: childrenCount,
      infant: infantCount,
    }));
  }, [adultsCount, childrenCount, infantCount]);

  const fetchofflineQueue = async () => {
    if (FormData.BookOffline) {
      const payload = {
        fromCode: FormData?.fromCode,
        toCode: FormData?.toCode,
        routeType: FormData?.routeType,
        departureDate: FormData?.departureDate,
      };

      try {
        const response = await dispatch(
          offlineTicketQueue({ payload })
        ).unwrap();
        if (response.data.status.success) {
          setofflineTicketQueue(response.data.data);
        } else {
          toast.error(response.data.message, { autoClose: 2000 });
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  }
  useEffect(() => {
    fetchofflineQueue()
  }, [FormData]);
  const [onShare, onSetShare] = useState(false);

  return (
    <div className="flex flex-col md:flex-row w-full min-h-screen bg-gray-50" ref={targetRef}>

      <Dialog
        open={GroupRequestLoad}
        onClose={() => setGroupRequestLoad(false)}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      >
        <div className="bg-white w-full max-w-md max-h-[90vh] rounded-2xl shadow-lg flex flex-col">

          {/* Header */}
          <div className="relative border-b px-6 py-4">
            <h2 className="text-lg font-semibold text-center">
              Group Booking Request
            </h2>

            {/* Close button (right aligned) */}
            <button
              onClick={() => setGroupRequestLoad(false)}
              className="absolute right-4 top-4 text-2xl text-gray-500 hover:text-gray-700"
            >
              &times;
            </button>
          </div>

          {/* Scrollable content */}
          <div className="flex-1 overflow-y-auto px-6 py-4">
            <div className="w-full">

              <div className="grid grid-cols-3 gap-2 mb-2">
                <div>
                  <label className="block text-xs text-gray-700 mb-1">Adult(s)</label>
                  <div className="flex items-center border border-gray-300 rounded-lg bg-white overflow-hidden">
                    <button
                      onClick={() => setAdultsCount(Math.max(1, adultsCount - 1))}
                      className="px-2 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                      aria-label="Decrease adults"
                    >
                      <Minus className="w-3.5 h-3.5" />
                    </button>
                    <span className="flex-1 text-center text-sm font-medium text-gray-800">{adultsCount}</span>
                    <button
                      onClick={() => setAdultsCount(adultsCount + 1)}
                      className="px-2 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                      aria-label="Increase adults"
                    >
                      <Plus className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-xs text-gray-700 mb-1">Child(s)</label>
                  <div className="flex items-center border border-gray-300 rounded-lg bg-white overflow-hidden">
                    <button
                      onClick={() => setChildrenCount(Math.max(0, childrenCount - 1))}
                      className="px-2 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                      aria-label="Decrease children"
                    >
                      <Minus className="w-3.5 h-3.5" />
                    </button>
                    <span className="flex-1 text-center text-sm font-medium text-gray-800">{childrenCount}</span>
                    <button
                      onClick={() => setChildrenCount(childrenCount + 1)}
                      className="px-2 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                      aria-label="Increase children"
                    >
                      <Plus className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-xs text-gray-700 mb-1">Infant(s)</label>
                  <div className="flex items-center border border-gray-300 rounded-lg bg-white overflow-hidden">
                    <button
                      onClick={() => setInfantCount(Math.max(0, infantCount - 1))}
                      className="px-2 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                      aria-label="Decrease infants"
                    >
                      <Minus className="w-3.5 h-3.5" />
                    </button>
                    <span className="flex-1 text-center text-sm font-medium text-gray-800">{infantCount}</span>
                    <button
                      onClick={() => setInfantCount(infantCount + 1)}
                      className="px-2 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                      aria-label="Increase infants"
                    >
                      <Plus className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>
              </div>
              {/* No. of People */}
              <div className="mb-1 flex items-center gap-3 rounded-xl border border-gray-300 bg-[#f9f5f8] px-4 py-3">
                <Users className="h-5 w-5 text-gray-600" />
                <input
                  readOnly
                  type="number"
                  placeholder="No. of People"
                  value={grouprequestData.numberOfPax}
                  onChange={(e) =>
                    setgrouprequestData((prev) => ({
                      ...prev,
                      numberOfPax: e.target.value,
                    }))
                  }
                  className="w-full bg-transparent text-gray-800 outline-none"
                />
              </div>
              {errors.numberOfPax && (
                <p className="mb-3 text-sm text-red-500">{errors.numberOfPax}</p>
              )}

              {/* Name */}
              <div className="mb-1 flex items-center gap-3 rounded-xl border border-gray-300 bg-[#f9f5f8] px-4 py-3">
                <User className="h-5 w-5 text-gray-600" />
                <input
                  type="text"
                  placeholder="Full Name"
                  value={grouprequestData.name}
                  onChange={(e) =>
                    setgrouprequestData((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                  className="w-full bg-transparent text-gray-800 outline-none"
                />
              </div>
              {errors.name && (
                <p className="mb-3 text-sm text-red-500">{errors.name}</p>
              )}

              {/* Email */}
              <div className="mb-1 flex items-center gap-3 rounded-xl border border-gray-300 bg-[#f9f5f8] px-4 py-3">
                <Mail className="h-5 w-5 text-gray-600" />
                <input
                  type="email"
                  placeholder="Email Address"
                  value={grouprequestData.email}
                  onChange={(e) =>
                    setgrouprequestData((prev) => ({
                      ...prev,
                      email: e.target.value,
                    }))
                  }
                  className="w-full bg-transparent text-gray-800 outline-none"
                />
              </div>
              {errors.email && (
                <p className="mb-3 text-sm text-red-500">{errors.email}</p>
              )}

              {/* Mobile */}
              <div className="mb-4 flex items-center gap-3 rounded-xl border border-gray-300 bg-[#f9f5f8] px-4 py-3">
                <Phone className="h-5 w-5 text-gray-600" />
                <input
                  type="tel"
                  placeholder="Mobile Number"
                  value={grouprequestData.mobile}
                  onChange={(e) =>
                    setgrouprequestData((prev) => ({
                      ...prev,
                      mobile: e.target.value,
                    }))
                  }
                  className="w-full bg-transparent text-gray-800 outline-none"
                />
              </div>
              {errors.mobile && (
                <p className="mb-4 text-sm text-red-500">{errors.mobile}</p>
              )}

              {/* Button */}
              <button
                type="button"
                onClick={handleGroupRequestSubmit}
                className="w-full rounded-xl bg-blue-500 py-3 text-lg font-medium text-white shadow-md transition hover:bg-blue-600"
              >
                Send Request
              </button>

            </div>
          </div>
        </div>
      </Dialog>

      <main className="flex-1 p-4" >
        <SearchSummaryBar setOpen={setOpen} open={open} FormData={FormData} onSetShare={onSetShare} onShare={onShare} />
        {open && (
          <SearchForm FormData={FormData} />
        )}
        {loading ? (
          <>
            <FlightSearchSkeleton />
          </>
        ) : (
          <div className="mt-2">
            {loading2 && (
              <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
                <div className="h-2.5 bg-blue-500 animate-progress"></div>
              </div>
            )}
            {(() => {
              if (!loading && FormData.routeType == 1 && (filteredOutboundFlights.length > 0 || outboundFull.length > 0)) {
                return (
                  <>

                    <OneWayResult outbound={visibleFlights} FormData={FormData} handleBookNow={handleBookNow} handlFlightDeatils={handlFlightDeatils}
                      FiltStop={Stops} FiltPrice={FiltPrice} FiltAirline={FiltAirline}
                      FiltFareClassOutbound={FiltFareClassOutbound}
                      handleChangeStops={handleChangeStops}
                      applyFilters={applyFilters}
                      handleChangeAirlines={handleChangeAirlines}
                      setPriceRange={setPriceRange}
                      priceRangeFilter={priceRangeFilter}
                      PriceRange={PriceRange}
                      selectedDeparture={selectedDeparture}
                      selectedArrival={selectedArrival}
                      handleChangeDeparture={handleChangeDeparture}
                      setSelectedDeparture={setSelectedDeparture}
                      handleChangeArrival={handleChangeArrival}
                      setSelectedArrival={setSelectedArrival}
                      handleChangeFarepol={handleChangeFarepol}
                      selectedFarepol={selectedFarepol}
                      handleFareClassOutbound={handleFareClassOutbound}
                      user={user}
                      onShare={onShare}
                      onSetShare={onSetShare}

                    />
                    {visibleCount < filteredOutboundFlights.length && (
                      <div
                        ref={loaderRef}
                        className="h-10 flex items-center justify-center text-gray-500 ssssss"
                      >
                        Loading more...
                      </div>
                    )}

                  </>
                )
              } else if (!loading && FormData.routeType == 2 && FormData.interNationalSearch == 0 && (filteredOutboundFlights.length > 0 || outboundFull.length > 0) && (filteredInboundFlights.length > 0 || inboundFull.length > 0)) {
                return (
                  <>


                    <RoundTripResults outbound={visibleFlights} inbound={visibleFlightsRound} FormData={FormData} handleBookNow={handleBookNow} handlFlightDeatils={handlFlightDeatils}
                      FiltPrice={FiltPrice}
                      FiltAirline={FiltAirline}
                      handleChangeStopsInbound={handleChangeStopsInbound}
                      applyFilters={applyFilters}
                      selectedStopsInbound={selectedStopsInbound}
                      FiltStop={Stops}
                      setPriceRange={setPriceRange}
                      priceRangeFilter={priceRangeFilter}
                      PriceRange={PriceRange}
                      handleChangeStops={handleChangeStops}
                      handleChangeAirlinesInbound={handleChangeAirlinesInbound}
                      handleChangeAirlines={handleChangeAirlines}
                      selectedDeparture={selectedDeparture}
                      selectedDepartureInbound={selectedDepartureInbound}
                      selectedArrival={selectedArrival}
                      selectedArrivalInbound={selectedArrivalInbound}
                      handleChangeArrivalInbound={handleChangeArrivalInbound}
                      handleChangeDepartureInbound={handleChangeDepartureInbound}
                      handleChangeDeparture={handleChangeDeparture}
                      handleChangeArrival={handleChangeArrival}
                      setShowSpecialReturn={setShowSpecialReturn}
                      showSpecialReturn={showSpecialReturn}
                      FiltAirlineSSP={FiltAirlineSSP}
                      handleAirlineNameSSP={handleAirlineNameSSP}
                      handleChangeFarepol={handleChangeFarepol}
                      selectedFarepol={selectedFarepol}
                      FiltFareClassOutbound={FiltFareClassOutbound}
                      handleFareClassOutbound={handleFareClassOutbound}
                      handleFareClassInbound={handleFareClassInbound}
                      FiltFareClassInbound={FiltFareClassInbound}
                      user={user}
                      onShare={onShare}
                      onSetShare={onSetShare}
                    />
                    {/* {visibleCountRound < filteredInboundFlights.length && (
                      <div
                        ref={loaderRoundRef}
                        className="h-10 flex items-center justify-center text-gray-500"
                      >
                        Loading more...
                      </div>
                    )}
                    {visibleCount < filteredOutboundFlights.length && (
                      <div
                        ref={loaderRef}
                        className="h-10 flex items-center justify-center text-gray-500 dddddddd"
                      >
                        Loading more...
                      </div>
                    )} */}
                    {(visibleCountRound < filteredInboundFlights.length ||
                      visibleCount < filteredOutboundFlights.length) && (
                        <div
                          ref={(el) => {
                            // Assign refs conditionally
                            if (visibleCountRound < filteredInboundFlights.length) {
                              loaderRoundRef.current = el;
                            }
                            if (visibleCount < filteredOutboundFlights.length) {
                              loaderRef.current = el;
                            }
                          }}
                          className="h-10 flex items-center justify-center text-gray-500"
                        >
                          Loading more...
                        </div>
                      )}


                  </>
                )
              } else if (!loading && FormData.routeType == 2 && FormData.interNationalSearch == 1 && (filteredOutboundFlights.length > 0 || outboundFull.length > 0)) {
                return (
                  <>
                    <RoundInternationalResults outbound={visibleFlights} FormData={FormData} handleBookNow={handleBookNow} handlFlightDeatils={handlFlightDeatils}
                      FiltStop={Stops} FiltPrice={FiltPrice} FiltAirline={FiltAirline}
                      handleChangeStops={handleChangeStops}
                      applyFilters={applyFilters}
                      handleChangeAirlines={handleChangeAirlines}
                      setPriceRange={setPriceRange}
                      priceRangeFilter={priceRangeFilter}
                      PriceRange={PriceRange}
                      selectedDeparture={selectedDeparture}
                      selectedArrival={selectedArrival}
                      handleChangeDeparture={handleChangeDeparture}
                      setSelectedDeparture={setSelectedDeparture}
                      handleChangeArrival={handleChangeArrival}
                      setSelectedArrival={setSelectedArrival}
                      handleChangeFarepol={handleChangeFarepol}
                      selectedFarepol={selectedFarepol}
                      FiltFareClassOutbound={FiltFareClassOutbound}
                      handleFareClassOutbound={handleFareClassOutbound}
                    />
                    {visibleCount < filteredOutboundFlights.length && (
                      <div
                        ref={loaderRef}
                        className="h-10 flex items-center justify-center text-gray-500"
                      >
                        Loading more...
                      </div>
                    )}
                  </>

                )
              } else if (!loading) {
                return (
                  <NomoreData message={'No Flights Found'} FormData={FormData} />
                )
              }
            })()}
            {/* <OneWayResult /> */}
          </div>
        )}


      </main>

      <AnimatePresence>
        {isSectorModalOpen && (
          <div className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50">
            {/* Sliding Panel */}
            <motion.div
              initial={{ x: "100%" }} // start from right outside screen
              animate={{ x: "0%" }} // slide till half of screen
              exit={{ x: "100%" }} // slide back out
              transition={{ type: "tween", duration: 0.4 }}
              className="bg-white w-full max-w-lg md:max-w-2xl lg:max-w-3xl h-full rounded shadow-lg p-4"
            >
              {/* Header Row */}
              <div className="flex items-center justify-between w-full border-b pb-2 mb-2">
                <h2 className="text-lg font-semibold">Flight Detail</h2>
                <button
                  onClick={() => setIsModalSector(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X size={20} />
                </button>
              </div>

              {/* Form (same as yours) */}
              <div className="w-full">
                {/* Tab Header */}
                <div className="flex border-b rounded-t-md overflow-hidden">
                  {tabs.map((tab) => (
                    <button
                      key={tab.key}
                      // onClick={() => setActiveTab(tab.key)}
                      onClick={() => {
                        setActiveTab(tab.key);
                        if (tab.key === "cancellation") {
                          handlFareRules();
                        }
                      }}
                      className={`flex-1 text-[12px] font-medium px-3 py-2 text-center transition ${activeTab === tab.key
                        ? "bg-blue-500 text-white"
                        : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                        }`}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                {/* Tab Content */}
                <div className="p-2 border rounded-b-lg bg-white">
                  {activeTab === "flight" && (
                    <div className="max-h-[75vh] overflow-y-auto pr-2">
                      {/* === Flight Information === */}
                      <div className="space-y-4">
                        {/* First Segment */}
                        {FlightSelected?.Segments.map((SegItem, Segkey) => (
                          <>
                            <div className="flex items-center justify-between  pb-4" key={Segkey}>
                              <div className="flex items-center gap-2">
                                <img src={SegItem.filePath} alt={SegItem.AirlineName} className="object-contain rounded-md  h-8" />
                                <div>
                                  <p className="font-semibold">{SegItem.AirlineName}</p>
                                  <p className="text-xs text-gray-500">{SegItem.FlightNumber} <br /> {FlightPrice?.FareClass}</p>
                                </div>
                              </div>
                              <div className="text-right">
                                <p className="text-lg font-semibold">{format(new Date(SegItem.originDepTime), "HH:mm")}</p>
                                <p className="text-sm text-gray-600">{SegItem.originCityName} ({SegItem.originAirportCode})</p>
                                <p className="text-sm text-gray-600">{SegItem.originAirportName} <br />
                                  {SegItem.DepTerminal}, ({SegItem.originCountryName})</p>
                                <p className="text-xs text-gray-500">{format(new Date(SegItem.originDepTime), "MMM dd, EEE yyyy")}</p>
                              </div>
                              <div className="text-center text-sm text-gray-600">
                                ⏱ {SegItem.FlightDuration}
                              </div>
                              <div className="text-right">
                                <p className="text-lg font-semibold">{format(new Date(SegItem.destinationArrTime), "HH:mm")}</p>
                                <p className="text-sm text-gray-600">{SegItem.destinationCityName} ({SegItem.destinationAirportCode})</p>
                                <p className="text-sm text-gray-600">{SegItem.destinationAirportName} <br />
                                  {SegItem.ArrTerminal}, ({SegItem.destinationCountryName})</p>
                                <p className="text-xs text-gray-500">{format(new Date(SegItem.destinationArrTime), "MMM dd, EEE yyyy")}</p>
                              </div>
                            </div>

                            {SegItem.GroundTime > 0 && (
                              <div className="flex items-center justify-center my-2">
                                <div className="flex-1 border-t border-gray-300"></div>
                                <span className="mx-4 px-3 py-1 rounded-full bg-gray-100 border text-red-500 text-sm font-medium whitespace-nowrap">
                                  Change Plane at {SegItem.LAYOVERCity}, Layover Time : {SegItem.LAYOVERDuration}
                                </span>
                                <div className="flex-1 border-t border-gray-300"></div>
                              </div>
                            )}
                          </>
                        ))}


                      </div>
                    </div>
                  )}

                  {activeTab === "fare" && (
                    <div className="w-full max-h-[75vh] overflow-y-auto pr-2">
                      <table className="w-full text-sm border border-gray-200">
                        <thead className="bg-blue-100">
                          <tr>
                            <th className="text-left px-4 py-2 font-semibold">TYPE</th>
                            <th className="text-left px-4 py-2 font-semibold">Fare</th>
                            <th className="text-left px-4 py-2 font-semibold">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {FlightPrice?.FareBreak.map((fareval, FK) => (
                            <React.Fragment key={FK + 'FKFK'}>
                              <tr className="bg-blue-50">
                                <td colSpan="3" className="px-4 py-2 font-medium text-gray-700">
                                  Fare Details for {fareval.PaxType}
                                </td>
                              </tr>
                              <tr>
                                <td className="px-6 py-2 text-gray-600">Base Price</td>
                                <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={(fareval.BaseFare / fareval.PassengerCount)} /> × {fareval.PassengerCount}</td>
                                <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={(fareval.BaseFare)} /></td>
                              </tr>
                              <tr>
                                <td className="px-6 py-2 text-gray-600 flex items-center gap-1">
                                  Taxes and fees
                                  <span className="text-orange-500 font-bold cursor-pointer">i</span>
                                </td>
                                <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={((fareval.Tax + fareval.FixedMarkUp + fareval.GSTOnMarkUp + fareval.agent_markup) / fareval.PassengerCount)} /> × {fareval.PassengerCount}</td>
                                <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={(fareval.Tax + fareval.FixedMarkUp + fareval.GSTOnMarkUp + fareval.agent_markup)} /></td>
                              </tr>
                              {fareval?.ARF > 0 && (
                                <tr>
                                  <td className="px-6 py-2 text-gray-600 flex items-center gap-1">
                                    Airline Reissue Fee
                                  </td>
                                  <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={((fareval.ARF) / fareval.PassengerCount)} /> × {fareval.PassengerCount}</td>
                                  <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={(fareval.ARF)} /></td>
                                </tr>
                              )}
                              {fareval?.RSSR !== null && fareval?.RSSR < 0 && (
                                <>
                                  <tr>
                                    <td className="px-6 py-2 text-gray-600 flex items-center gap-1">
                                      Refundable Ancillaries
                                    </td>
                                    <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={((fareval.RSSR) / fareval.PassengerCount)} /> × {fareval.PassengerCount}</td>
                                    <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={(fareval.RSSR)} /></td>
                                  </tr>
                                  <tr>
                                    <td className="px-6 py-2 text-gray-600 flex items-center gap-1">
                                      Recalled Ancillaries Commision
                                    </td>
                                    <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={((fareval.RSSRC) / fareval.PassengerCount)} /> × {fareval.PassengerCount}</td>
                                    <td className="px-4 py-2"><CurFt currency={fareval?.Currency || "INR"} price={(fareval.RSSRC)} /></td>
                                  </tr>
                                </>
                              )}

                            </React.Fragment>
                          ))}

                        </tbody>

                        {/* Grand Total */}
                        <tfoot>
                          <tr className="border-t border-gray-300 bg-gray-50">
                            <td colSpan="2" className="px-4 py-2 font-semibold text-lg">
                              Total
                            </td>
                            <td className="px-4 py-2 font-semibold text-lg"><CurFt currency={FlightPrice?.symbol || "INR"} price={(FlightPrice?.PublishedFare)} /></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  )}

                  {activeTab === "baggage" && (
                    <div className="w-full text-sm max-h-[75vh] overflow-y-auto pr-2">
                      <div className="text-sm">
                        <table className="w-full border border-gray-300 text-sm">
                          <thead>
                            <tr className="bg-blue-100">
                              <th className="border border-gray-300 px-4 py-2 text-left font-semibold">Sector</th>
                              <td className="border border-gray-300 px-4 py-2 text-left font-semibold">Check-In</td>
                              <td className="border border-gray-300 px-4 py-2 text-left font-semibold">Cabin</td>
                            </tr>
                          </thead>
                          <tbody>
                            {FlightPrice && (
                              Object.keys(FlightPrice?.tripbinfo).map((value, Segkey) => (
                                <tr key={Segkey} className="border-t">
                                  <td className="border border-gray-300 px-4 py-3">
                                    {value}
                                  </td>
                                  <td className="border border-gray-300 px-4 py-3">
                                    {FlightPrice?.tripbinfo[value].ADULT && (
                                      <p>ADULT - {FlightPrice?.tripbinfo[value].ADULT.checkin}</p>
                                    )}
                                    {FlightPrice?.tripbinfo[value].CHILD && (
                                      <p>CHILD - {FlightPrice?.tripbinfo[value].CHILD.checkin}</p>
                                    )}
                                    {FlightPrice?.tripbinfo[value].INFANT && (
                                      <p>INFANT - {FlightPrice?.tripbinfo[value].INFANT.checkin}</p>
                                    )}
                                  </td>
                                  <td className="border border-gray-300 px-4 py-3">
                                    {FlightPrice?.tripbinfo[value].ADULT && (
                                      <p>ADULT - {FlightPrice?.tripbinfo[value].ADULT.cabin}</p>
                                    )}
                                    {FlightPrice?.tripbinfo[value].CHILD && (
                                      <p>CHILD - {FlightPrice?.tripbinfo[value].CHILD.cabin}</p>
                                    )}
                                    {FlightPrice?.tripbinfo[value].INFANT && (
                                      <p>INFANT - {FlightPrice?.tripbinfo[value].INFANT.cabin}</p>
                                    )}
                                  </td>
                                </tr>
                              ))
                            )}

                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {activeTab === "cancellation" && (
                    <div className="max-h-[75vh] overflow-y-auto pr-2">
                      {fareRulesStatus === "loading" ? (
                        <>
                          <div className="mt-6 flex flex-col items-center justify-center">
                            <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
                            <p className="mt-4 text-gray-600">
                              Please wait loading fare rules. <br />
                              This might take a few seconds.
                            </p>
                          </div>
                        </>
                      ) : (
                        renderFarePolicy()
                      )}
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FlightResultsPage;
